import React from 'react';

const MapViewPage = () => {
  return (
    <div>
      <h1>MapView Page</h1>
    </div>
  );
};

export default MapViewPage;
